import CIMInvoiceSimulationPage from './CIMInvoiceSimulationPage';

export default CIMInvoiceSimulationPage;
